module.exports = __webpack_public_path__ + "static/img/icon-p2.0b548ce6.png";